import IPage from "../../../interfaces/page";
import ForgotPasswordFormComponent from "../../Components/ForgotPasswordForm/ForgotPasswordForm.component";
import PublicLayout from "../../layouts/Public/Public.layout";

const ForgotPasswordPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <PublicLayout component={ForgotPasswordFormComponent} />
}

export default ForgotPasswordPage;